import React from 'react';

import { Card, CardContent, CardMedia, Skeleton } from '@mui/material';

import styles from './ListingCard.module.css';

export const ListingCardSkeleton = () => {
  return (
    <Card className={styles.root}>
      <CardMedia>
        <Skeleton
          width="100%"
          height="53%"
          variant="rectangular"
          className={styles.media}
        />
      </CardMedia>
      <CardContent className={styles.cardContent}>
        <Skeleton variant="text" height={24} />
        <Skeleton variant="text" height={20} width="80%" />
        <Skeleton variant="text" height={20} width="60%" />
        <Skeleton variant="text" height={28} width="50%" />
      </CardContent>
    </Card>
  );
};
